import dayjs from 'dayjs';
import type { BtlApplication } from '@api/btlApplicationForm/types';

export const MINIMUM_ADDRESS_HISTORY_YEARS = 3;

interface AddressHistoryDateFields {
  moveInDate?: Date | string | null;
}

export function doesAddressHistoryCoverMinimumYears(
  addressHistory: AddressHistoryDateFields[] | undefined | null,
  minimumYears = MINIMUM_ADDRESS_HISTORY_YEARS,
): boolean {
  if (!addressHistory?.length) {
    return false;
  }

  const earliestMoveInDate = addressHistory
    .map(entry => dayjs(entry.moveInDate))
    .filter(date => date.isValid())
    .sort((left, right) => left.valueOf() - right.valueOf())[0];

  if (!earliestMoveInDate) {
    return false;
  }

  return dayjs().diff(earliestMoveInDate, 'year') >= minimumYears;
}

export function hasInsufficientApplicantAddressHistory(application?: BtlApplication | null): boolean {
  const individuals = application?.borrower?.individuals ?? [];

  if (individuals.length === 0) {
    return false;
  }

  return individuals.some(individual => !doesAddressHistoryCoverMinimumYears(individual.addressHistory));
}
